import React, { useEffect, useState } from 'react';
import Header from '../../organisms/header/header';


const RestrictedPage = () => {
 
  return [
    <Header key="homepage-header"  />,
    <div key="homepage-container" className="homepage__container container">
      <div key="restricted-text" className="restricted__text">
        <h1 style={{fontWeight:'bold'}}>Restricted Access</h1>
        <h3>You do not have permission to view this page</h3>
      </div>
    </div>,
  ];
};

export default RestrictedPage;
